<!-- @catalog Column-header label for narrow columns, as in the learning goals matrix: the text rises at 45° from the cell's bottom centre, is cut with an ellipsis past 100px and shows in full in a tooltip. Sizes itself (92px tall), so the header row only needs to grow with it. -->
<template>
  <span class="c-slanted-header-label">
    <span class="c-slanted-header-label__text">
      <c-tooltip>{{ label }}</c-tooltip>
      {{ label }}
    </span>
  </span>
</template>

<script setup lang="ts">
defineProps<{ label: string }>();
</script>

<style lang="scss" scoped>
.c-slanted-header-label {
  // The text's foot sits at the cell's horizontal centre, above whatever the
  // column holds; the rotation itself takes no layout space. A 100px label
  // turned 45° around its bottom-left corner rises 88px, hence the height.
  @apply tw-flex tw-h-[92px] tw-items-end tw-pl-[50%];

  &__text {
    @apply tw-w-[100px] tw-min-w-[100px] tw-origin-bottom-left -tw-rotate-45 tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap;
  }
}
</style>
